import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BookingModel } from 'src/app/_models/booking.model';
import { BookingService } from 'src/app/_services/booking.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { SpaceService } from 'src/app/_services/space.service';
import { CompanyService } from 'src/app/app/company/company.service';
import { DictionaryService } from 'src/app/dictionary';

@Component({
  selector: 'app-parking-report-view',
  templateUrl: './parking-report-view.component.html',
  styleUrls: [
    './parking-report-view.component.scss',
    '../../../../_styles/ion-grid-content-table.scss',
    '../../../../app/_component/_space/space-booking-view/space-booking-view.component.scss'
  ],
})
export class ParkingReportViewComponent implements OnInit {

  constructor(
    public dictionaryServ: DictionaryService,
    public p: ThisPlatform,
    public translateService: TranslateService,
    public bookingServ: BookingService,
    public translate: TranslateService,
    public spaceService: SpaceService,
    public companyServ: CompanyService,
  ) {}

  mobile = false;

  @Input()
  row: BookingModel;

  @Input()
  customData: string;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {}

}
